import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, Inbox } from "lucide-react";

import setAuthToken from "../../../utils/setAuthToken";
import { formatDateWidget } from "../../../utils/dateUtils";

import { Spinner, ContactStatusBadge } from "../../../design-system";

function truncate(text, n = 80) {
  if (!text) return "";
  return text.length <= n ? text : text.substring(0, n) + "…";
}

class LatestContacts extends Component {
  constructor(props) {
    super(props);
    this.state = { contacts: [], loading: true };
  }

  componentDidMount() {
    this.loadContacts();
  }

  loadContacts = async () => {
    try {
      const token = localStorage.getItem("jwtToken");
      if (token) setAuthToken(token);
      const response = await axios.get("/api/contacts?limit=5");
      if (response.data.success) {
        this.setState({ contacts: response.data.contacts || [], loading: false });
      }
    } catch (error) {
      console.error("Error loading contacts:", error);
      this.setState({ loading: false });
    }
  };

  render() {
    const { contacts, loading } = this.state;

    return (
      <div className="flex flex-col h-full">
        <header className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h3 className="text-sm font-bold tracking-tight">Derniers contacts</h3>
          <Link to="/dashboard/contacts" className="text-xs font-medium text-mute hover:text-text inline-flex items-center gap-1">
            Voir tout <ArrowUpRight className="w-3 h-3" strokeWidth={1.8} />
          </Link>
        </header>
        <div className="flex-1">
          {loading ? (
            <div className="flex items-center justify-center py-8 text-mute"><Spinner size="sm" /></div>
          ) : contacts.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-8 text-center text-mute text-sm">
              <Inbox className="w-5 h-5 mb-2 text-mute-2" strokeWidth={1.6} />
              Aucun contact
            </div>
          ) : (
            <ul className="divide-y divide-border">
              {contacts.map((contact) => (
                <li key={contact.id} className="px-4 py-3">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <span className="text-sm font-semibold text-text leading-tight">{contact.name}</span>
                    <ContactStatusBadge status={contact.status} size="sm" />
                  </div>
                  <div className="flex items-center gap-2 text-[11.5px] text-mute mb-1">
                    <span className="truncate">{contact.email}</span>
                    <span className="text-mute-2">·</span>
                    <span className="font-mono shrink-0">{formatDateWidget(contact.createdAt)}</span>
                  </div>
                  {contact.subject && (
                    <div className="text-[11.5px] text-mute mt-0.5 font-serif italic line-clamp-1">
                      — {truncate(contact.subject, 60)}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  }
}

export default LatestContacts;
